export const areaChartData = {
    chartData: {
        Semana: [
            { name: "Lun", uv: 4000, pv: 2400, amt: 2400 },
            { name: "Mar", uv: 3000, pv: 1398, amt: 2210 },
            { name: "Mié", uv: 2000, pv: 9800, amt: 2290 },
            { name: "Jue", uv: 2780, pv: 3908, amt: 2000 },
            { name: "Vie", uv: 1890, pv: 4800, amt: 2181 },
            { name: "Sáb", uv: 2390, pv: 3800, amt: 2500 },
        ],
        Mes: [
            { name: "Sem 1", uv: 15000, pv: 12000, amt: 11000 },
            { name: "Sem 2", uv: 18000, pv: 14000, amt: 13000 },
            { name: "Sem 3", uv: 16000, pv: 13500, amt: 12500 },
            { name: "Sem 4", uv: 20000, pv: 16000, amt: 15000 },
        ],
        Año: [
            { name: "Ene", uv: 40000, pv: 24000, amt: 24000 },
            { name: "Feb", uv: 30000, pv: 13980, amt: 22100 },
            { name: "Mar", uv: 20000, pv: 98000, amt: 22900 },
            { name: "Abr", uv: 27800, pv: 39080, amt: 20000 },
            { name: "May", uv: 18900, pv: 48000, amt: 21810 },
            { name: "Jun", uv: 23900, pv: 38000, amt: 25000 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$24,500",
            percentageValue: 12.5,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$56,000",
            percentageValue: 8.7,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$286,880",
            percentageValue: -2.3,
            percentageText: "vs año anterior"
        }
    }
};

export const barChartData = {
    chartData: {
        Semana: [
            { name: "Lun", uv: 1000, pv: 1800, amt: 1600 },
            { name: "Mar", uv: 2500, pv: 1200, amt: 1000 },
            { name: "Mié", uv: 3000, pv: 1500, amt: 1200 },
            { name: "Jue", uv: 1200, pv: 1900, amt: 1700 },
            { name: "Vie", uv: 2800, pv: 2400, amt: 2000 },
        ],
        Mes: [
            { name: "Sem 1", uv: 8000, pv: 7000, amt: 6500 },
            { name: "Sem 2", uv: 9500, pv: 8200, amt: 7800 },
            { name: "Sem 3", uv: 7800, pv: 6900, amt: 6200 },
            { name: "Sem 4", uv: 10200, pv: 9100, amt: 8600 },
        ],
        Año: [
            { name: "Q1", uv: 32000, pv: 28000, amt: 25000 },
            { name: "Q2", uv: 38000, pv: 32000, amt: 29000 },
            { name: "Q3", uv: 35000, pv: 30000, amt: 27000 },
            { name: "Q4", uv: 42000, pv: 36000, amt: 33000 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$18,200",
            percentageValue: 8.3,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$34,100",
            percentageValue: 12.7,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$147,000",
            percentageValue: -2.1,
            percentageText: "vs año anterior"
        }
    }
};

export const lineChartData = {
    chartData: {
        Semana: [
            { name: "Lun", uv: 1200, pv: 2800, amt: 2600 },
            { name: "Mar", uv: 2800, pv: 1400, amt: 2200 },
            { name: "Mié", uv: 1600, pv: 2200, amt: 2900 },
            { name: "Jue", uv: 3100, pv: 3700, amt: 5300 },
            { name: "Vie", uv: 3900, pv: 3100, amt: 3100 },
            { name: "Sáb", uv: 3400, pv: 3000, amt: 1700 },
        ],
        Mes: [
            { name: "Sem 1", uv: 1000, pv: 4500, amt: 2800 },
            { name: "Sem 2", uv: 4500, pv: 5800, amt: 2200 },
            { name: "Sem 3", uv: 3200, pv: 1600, amt: 1400 },
            { name: "Sem 4", uv: 6800, pv: 4200, amt: 3600 },
        ],
        Año: [
            { name: "Ene", uv: 28000, pv: 22000, amt: 20000 },
            { name: "Feb", uv: 32000, pv: 26000, amt: 24000 },
            { name: "Mar", uv: 35000, pv: 29000, amt: 27000 },
            { name: "Abr", uv: 31000, pv: 25000, amt: 23000 },
            { name: "May", uv: 38000, pv: 32000, amt: 30000 },
            { name: "Jun", uv: 41000, pv: 35000, amt: 33000 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$42,100",
            percentageValue: -3.2,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$67,400",
            percentageValue: 5.8,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$325,000",
            percentageValue: 15.2,
            percentageText: "vs año anterior"
        }
    }
};

export const pieChartData = {
    chartData: {
        Semana: [
            { name: "Ventas", value: 400 },
            { name: "Marketing", value: 300 },
            { name: "Desarrollo", value: 200 },
            { name: "Soporte", value: 100 },
        ],
        Mes: [
            { name: "Ventas", value: 1600 },
            { name: "Marketing", value: 1200 },
            { name: "Desarrollo", value: 800 },
            { name: "Soporte", value: 400 },
        ],
        Año: [
            { name: "Ventas", value: 19200 },
            { name: "Marketing", value: 14400 },
            { name: "Desarrollo", value: 9600 },
            { name: "Soporte", value: 4800 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$31,750",
            percentageValue: 15.7,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$89,200",
            percentageValue: -4.2,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$412,800",
            percentageValue: 22.3,
            percentageText: "vs año anterior"
        }
    }
};

export const interactivePieData = {
    chartData: {
        Semana: [
            { name: "Productos", value: 350 },
            { name: "Servicios", value: 250 },
            { name: "Consultoría", value: 180 },
            { name: "Otros", value: 120 },
        ],
        Mes: [
            { name: "Productos", value: 1400 },
            { name: "Servicios", value: 1000 },
            { name: "Consultoría", value: 720 },
            { name: "Otros", value: 480 },
        ],
        Año: [
            { name: "Productos", value: 16800 },
            { name: "Servicios", value: 12000 },
            { name: "Consultoría", value: 8640 },
            { name: "Otros", value: 5760 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$28,900",
            percentageValue: 9.8,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$76,200",
            percentageValue: 18.5,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$434,400",
            percentageValue: -6.7,
            percentageText: "vs año anterior"
        }
    }
};

export const usuariosData = [
    {
        id: 1,
        nombre: "Juan Pérez",
        email: "juan@empresa.com",
        departamento: "Desarrollo",
        estado: "activo",
    },
    {
        id: 2,
        nombre: "María García",
        email: "maria@empresa.com",
        departamento: "Diseño",
        estado: "activo",
    },
    {
        id: 3,
        nombre: "Carlos López",
        email: "carlos@empresa.com",
        departamento: "Marketing",
        estado: "pendiente",
    },
    {
        id: 4,
        nombre: "Ana Rodríguez",
        email: "ana@empresa.com",
        departamento: "Ventas",
        estado: "activo",
    },
    {
        id: 5,
        nombre: "Luis Martínez",
        email: "luis@empresa.com",
        departamento: "Soporte",
        estado: "inactivo",
    },
];

export const zoneOptions = [
    { value: "europa", label: "Europa" },
    { value: "mexico", label: "México" },
    { value: "no-goa", label: "Países no GOA" },
    { value: "asia", label: "Asia-Pacífico" },
];

export const departmentOptions = [
    { value: "desarrollo", label: "Desarrollo" },
    { value: "diseno", label: "Diseño" },
    { value: "marketing", label: "Marketing" },
    { value: "ventas", label: "Ventas" },
    { value: "rrhh", label: "Recursos Humanos" },
];

export const priorityOptions = [
    { value: "low", label: "Baja Prioridad" },
    { value: "medium", label: "Prioridad Media" },
    { value: "high", label: "Alta Prioridad" },
    { value: "urgent", label: "Urgente", disabled: true },
];

export const columnasUsuarios = [
    { key: "id", label: "ID", width: "60px" },
    { key: "nombre", label: "Nombre" },
    { key: "email", label: "Email", isLink: true },
    { key: "departamento", label: "Departamento" },
    {
        key: "estado",
        label: "Estado",
        type: "badge",
        badgeConfig: {
            activo: {
                variant: "success",
                label: "Activo",
            },
            pendiente: {
                variant: "warning",
                label: "Pendiente",
            },
            inactivo: {
                variant: "danger",
                label: "Inactivo",
            },
        },
    },
];